var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptions = function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 29 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.786 5.937a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732m0 5.429a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732M7.92 14.928a1.866 1.866 0 1 0 3.732 0 1.866 1.866 0 0 0-3.732 0M19.286 5.937a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732m0 5.429a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732m-1.866 3.562a1.866 1.866 0 1 0 3.732 0 1.866 1.866 0 0 0-3.732 0"
  })));
};
export default SvgOptions;